/* eslint-disable import/prefer-default-export */

export enum colors {
  white = 'white',
  black = 'black',
  yubiGreen = '#9aca3c',
  yubiGreenHover = '#7ca230',
  tealBlue = '#0080ac',
  secondaryDark = '#004461',
  lightGreyBlue = '#83b9d6',
  brownishGrey = '#676767',
  silver = '#eaecec',
  silverTwo = '#c7caca',
  denim = '#417488',
  denimTwo = '#325f74',
  denimTwoDarker = '#274c61',
  darkGrey = '#e8e8e8',
  warmGrey = '#939292',
  lightBlack = '#373f41',
  lightGrey = '#f4f5f4',
  lilac = '#DAEDF5',
  grey10 = '#6D6D6D',
  grey9 = '#3D4133',
  grey7 = '#868b79',
  grey8 = '#686F59',
  grey2 = '#E0E1DD',
  blue0 = '#F5FAFC',
  blue1 = '#E0F0F7',
  blue2 = '#CAE5F1',
  blue6 = '#4FAAD1',
  blue7 = '#1E92C5',
  cyan0 = '#F2FCFA',
  cyan1 = '#D5F4EE',
  fuschia0 = '#FCF8FD',
  fuschia1 = '#F6E9F9',
  grey = '#8C8C8C',
  greyBorder = '#C2C5BC',
  lime1 = ' #E7F2CD',
  lime4 = '#AAD24F',
  lime8 = '#537700',
  gray0 = '#F9F9F9',
  gray1 = '#EDEEEB',
  indigo0 = '#F8F9FD',
  indigo1 = '#EAEDFA',
  red9 = '#ff0000',
  red8 = '#C92F4E',
  red = '#C0410B',
  hovergrey = '#C4C4C4',
  yellow0 = '#FBF9F1',
  yellow1 = '#F4EED5',
  yellow2 = '#ECE1B5',
  yellow4 = '#D9C36C',
  yellow5 = '#CEB140',
  yellow6 = ' #C09C0C',
  yellow7 = '#A78500',
  yellow8 = '#846900',
  green = '#84BD00',
  violet0 = '#FAF9FD',

  // badge color
  teal = '#006081',

  // Toast Colors
  toastYellow = '#eac040',
  toastYellowBorder = '#faebcc',
  toastBlue = '#d9edf7',
  toastBlueBorder = '#bce8f1',
  toastGreen = '#cae693',
  toastGreenBorder = '#d6e9c6,',
  toastRed = '#bf2029',
  toastRedBorder = '#ebccd1',

  // New For YEP
  disableGrey = '#9DA293',
  disabledGrey = '#D9D9D9',
  disabledGreyText = '#C0C0C0',
  lightLightGrey = '#E2E5E6',
  silverEvenDarker = '#BFBFBF',
  silverDarkText = '#9B9B9B',
  tableRollerOver = '#F8F8F8',
  borderColor = '#B1B4A9',

  neutral0 = '#F9FAFB',
  neutral1 = '#EDF0F2',
  neutral2 = '#D8D8D8',
  neutral3 = '#939393',
  neutral4 = '#767676',
  neutral5 = '#4A4A4A',
  neutral6 = '#333333',
  neutral7 = '#777777',
  primaryAccessible10 = '#F1F7E6',
  primaryAccessible70 = '#A0C44D',
  primaryAccessible100 = '#77AA00',
  secondary50 = '#80B9D2',
  secondary100 = '#0073A5',
  secondary140 = '#004563',
  orange1 = '#F8EBE5',
  orange3 = '#EECCBD',
  orange5 = '#E1A58C',

  // subscription colors
  grey200 = '#EEEEEE',
  grey300 = '#E0E0E0',
  grey400 = '#BDBDBD',
  grey500 = '#9E9E9E',
  violet1 = '#F0EBFA',
  violet2 = '#E5DDF6',
  violet3 = '#D9CDF2',
  violet5 = '#BCA9E9',
  blue3 = '#75BCDB',
  indigo3 = '#CAD2F1',
  indigo5 = '#A3B1E7',
  yubiGreen2 = '#5F8800',
  teal50 = '#E0F2F1',
  teal100 = '#B2DFDB',
  teal200 = '#80CBC4',
  teal300 = '#4DB6AC',
  teal500 = '#009688',
  teal700 = '#00796B',
  blue600 = '#039BE5',

  warningMain = '#ED6C02',
}

export type YubiColorTypes = keyof typeof colors;

export const dimensions = {
  container: {
    max: '1460px',
    min: '200px',
  },
  box: {
    min: '250px',
  },
};
